<template>
  <div ref="protectedPage" class="universe-home">
    <div class="cosmic-background" aria-hidden="true"></div>

    <header class="site-header">
      <div class="brand-menu">
        <a
          class="brand-lockup"
          href="/"
          aria-label="宇宙之幂首页"
          aria-describedby="brandProfile"
        >
          <span class="brand-mark">
            <img
              src="/static/favicontu.ico"
              alt=""
              draggable="false"
              width="38"
              height="38"
            >
          </span>
          <h1>宇宙之幂 <span aria-hidden="true">|</span> <b lang="en">UniversePower</b></h1>
        </a>
        <section id="brandProfile" class="brand-profile" aria-label="宇宙之幂品牌简介">
          <span class="brand-profile-corners" aria-hidden="true"><i></i><i></i><i></i><i></i></span>
          <span class="brand-profile-scan" aria-hidden="true"></span>
          <div class="brand-profile-visual">
            <span class="brand-profile-kicker">UniversePower</span>
            <img
              src="/static/favicontu.ico"
              alt="宇宙之幂公司 Logo"
              draggable="false"
              width="112"
              height="112"
            >
            <strong>宇宙之幂</strong>
          </div>
          <div class="brand-profile-content">
            <h2>宇宙之幂</h2>
            <p>【宇宙之幂】拥有&lt;私域宇宙&gt;、&lt;现实宇宙&gt;、&lt;映射宇宙&gt;、&lt;平行宇宙&gt;、&lt;分类宇宙&gt;、&lt;支持宇宙&gt;，并拥有一切&lt;宇宙形态&gt;、&lt;宇宙意识&gt;、&lt;宇宙行为&gt;、&lt;宇宙力量&gt;、&lt;宇宙成品&gt;、&lt;宇宙内核&gt;。您可在【宇宙之幂】中快速创造、实现一切目标、产品、愿望。</p>
            <div class="brand-profile-company">宇宙之幂(深圳)科技集团有限公司</div>
          </div>
        </section>
      </div>
      <nav class="header-actions" aria-label="页面操作">
        <span class="download-menu">
          <a
            class="download-link"
            href=""
            aria-haspopup="true"
            @click.prevent
          >获取【宇宙之幂】</a>
          <span class="download-card" role="dialog" aria-label="扫码获取宇宙之幂">
            <span class="qr-effect-shell">
              <span class="qr-effect-corners" aria-hidden="true"><i></i><i></i><i></i><i></i></span>
              <span class="qr-effect-scan" aria-hidden="true"></span>
              <span class="qr-shell">
                <img
                  src="/static/775d4dcdc574aa111116ac10afbe9187.png"
                  alt="宇宙之幂下载二维码"
                  draggable="false"
                  width="206"
                  height="206"
                >
              </span>
            </span>
            <span class="download-card-caption">扫码获取宇宙之幂 APP</span>
          </span>
        </span>
        <button class="language-option" type="button" aria-label="切换为 English">English</button>
      </nav>
    </header>

    <main class="experience" aria-label="宇宙之幂产品宇宙">
      <div id="universeStage" class="universe-stage" aria-live="off"></div>
    </main>

    <footer class="site-footer">
      <div class="footer-row footer-primary">
        <span class="company-name">宇宙之幂（深圳）科技集团有限公司</span>
        <span class="footer-item">用户协议</span>
        <span class="footer-item">隐私政策</span>
        <span class="footer-item">投诉反馈</span>
      </div>
      <div class="footer-row footer-records">
        <span>粤ICP备2024237244号@2024 © 宇宙之幂</span>
      </div>
    </footer>
  </div>
</template>

<script>
import {
  configureUniverseBody,
  destroyUniverseExperience,
  loadUniverseExperience
} from '@/lib/universeExperience'
import { installImageProtection } from '@/lib/imageProtection'

export default {
  name: 'UniverseHome',
  mounted () {
    this.removeImageProtection = installImageProtection(document)
    configureUniverseBody()
    loadUniverseExperience().catch(error => {
      console.error('Universe experience failed to load', error)
    })
  },
  beforeDestroy () {
    destroyUniverseExperience()
    if (this.removeImageProtection) this.removeImageProtection()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/UniverseHome.vue